import { BrandType } from '../brand';

export interface CreateLeadGenerationPayload {
  description: string;
  bookingItemId?: number;
  type: LeadGenerationType;
  serviceDepartmentId?: number;
  addressId?: number;
  brand?: BrandType;
}

export const LeadGenerationStatus = {
  ACCEPTED: 'accepted',
  PENDING: 'pending',
  REJECTED: 'rejected'
} as const;

export type LeadGenerationStatusType = (typeof LeadGenerationStatus)[keyof typeof LeadGenerationStatus];

export const leadGenerationStatusLabels = {
  [LeadGenerationStatus.ACCEPTED]: 'Accepted',
  [LeadGenerationStatus.PENDING]: 'Pending',
  [LeadGenerationStatus.REJECTED]: 'Rejected'
} as const;

export const LeadGenerationType = {
  STONE_CHIP_REPAIR: 'stone_chip_repair',
  RIM_REPAIR: 'rim_repair',
  NEW_TIRES: 'new_tires'
} as const;

export type LeadGenerationType = (typeof LeadGenerationType)[keyof typeof LeadGenerationType];

export const leadGenerationTypeLabels = {
  [LeadGenerationType.STONE_CHIP_REPAIR]: 'Stone chip repair',
  [LeadGenerationType.RIM_REPAIR]: 'Rim repair',
  [LeadGenerationType.NEW_TIRES]: 'New tires'
} as const;
